import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';

import Button from '@/components/Button';
import ConfirmationCard, { ConfirmationCardProps } from '@/components/Cards/ConfirmationCard';

interface ConfirmShipmentProps {
  create: () => void;
  isPending: boolean;
  data: ConfirmationCardProps[];
}

const ConfirmShipment = ({ create, isPending, data }: ConfirmShipmentProps) => {
  const theme = useTheme();

  return (
    <Box>
      <Grid container size={{ xxs: 12 }} spacing={4} mt={4}>
        {data.map((item: ConfirmationCardProps, index: number) => (
          <ConfirmationCard key={index} {...item} />
        ))}
      </Grid>

      <Grid
        container
        size={{ xxs: 12 }}
        sx={{ marginTop: theme.spacing(4), justifyContent: 'end' }}
      >
        <Button
          variant="contained"
          onClick={create}
          disabled={isPending}
          sx={{
            minWidth: '120px',
            minHeight: '42px',
          }}
        >
          {isPending ? <CircularProgress size={20} sx={{ color: '#4caf50' }} /> : 'Confirmar'}
        </Button>
      </Grid>
    </Box>
  );
};

export default ConfirmShipment;
